<template>
  <span class="tooltip">
    <span @mouseenter="showTooltip = true" @mouseleave="showTooltip = false" class="tooltip__trigger">
      <slot name="trigger" />
    </span>
    <span v-if="showTooltip && $slots.content[0].text" class="tooltip__content">
      <slot name="content" />
    </span>
  </span>
</template>

<script>
export default {
  name: 'HMTooltip',
  data() {
    return {
      showTooltip: false,
    }
  },
}
</script>

<style scoped>
.tooltip {
  position: relative;
}

.tooltip__trigger {
  display: flex;
}

.tooltip__content {
  position: absolute;
  left: 40%;
  top: -30px;
  padding: 5px 10px;
  border-radius: 10px;
  border: 1px solid #EBE6DC;
  color: #6D6A5E;
  background-color: #FAF8F4;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 13px;
  line-height: 1.4;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: 'salt' on;
  white-space: nowrap;
  box-shadow: 0 1px 5px 0 rgba(159, 167, 177, 0.20);
  pointer-events: none;
  z-index: 5;
}
</style>